import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { FileServerStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/file-server-store-read-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { CopySource } from 'app/model/pipeline/copysource/copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FileServerStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        fileFilter: '*',
        deleteFilesAfterCompletion: '*'
    }
})
export class FileServerStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    FileServerStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<FileServerStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        if (model != null && resource != null && resource.fileFilter) {
            model.filePathMode = FilePathMode.FILEFILTER;
            ValueAdapter.toModel(model, FileServerStoreReadSettings.FILE_FILTER, resource.fileFilter);
        }
        ValueAdapter.toModel(
            model,
            FileServerStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );

        return model;
    }

    protected override async _toResource(settings: FileServerStoreReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        if (settings.filePathMode === FilePathMode.FILEFILTER) {
            resource.fileFilter =
                ValueAdapter.toResource(settings, FileServerStoreReadSettings.FILE_FILTER) || undefined;
        }
        resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
            settings,
            FileServerStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
        );

        return resource;
    }
}
